module.exports = __webpack_public_path__ + "img/desc.64362308.png";